import { NewsListPage } from "@components/pages/NewsListPage"
import { SiteShell } from "@components/SiteShell"
import { newsListPageQueryOptions } from "@data/publicPageDataQuery"
import { createFileRoute } from "@tanstack/react-router"
import { localizedRouteHead } from "@utils/routeHead"
import { pageLabels } from "@utils/routeLabels"

export const Route = createFileRoute("/$locale/news/")({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(newsListPageQueryOptions(params.locale as "en" | "ja")),
  head: ({ params }) => {
    const locale = params.locale as "en" | "ja"
    return localizedRouteHead({ locale, page: "news", path: `/${locale}/news` })
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { locale: routeLocale } = Route.useParams()
  const locale = routeLocale as "en" | "ja"
  const data = Route.useLoaderData()
  const labels = pageLabels(locale, "news")
  return (
    <SiteShell
      locale={locale}
      page={labels.page}
    >
      <NewsListPage
        data={data}
        locale={locale}
      />
    </SiteShell>
  )
}
